import { useMatch } from "@tanstack/react-router";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { workOrderRecordQuery } from "@/app/ProDrivers/WorkOrders/GraphQL/workOrdersQuery";

export function useWorkOrderRecord() {
  const match = useMatch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/_workOrderRecordSidebar/pro-drivers/work-orders/$id",
  });
  const { data } = useSuspenseGqlQuery(workOrderRecordQuery, {
    id: match.params.id,
  });

  if (!data.workOrder) {
    throw new Error("Work order not found");
  }

  return data.workOrder;
}
